/**
 * @generated SignedSource<<bd4227342e9ecb2e9d2338df013cfaf3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type queryAgentMentionsFragment$data = {
  readonly creatorType: string | null;
  readonly description: string | null;
  readonly id: string;
  readonly identityAccount: {
    readonly picture: AGG$URL;
  } | null;
  readonly identityAccountId: string | null;
  readonly name: string | null;
  readonly " $fragmentType": "queryAgentMentionsFragment";
};
export type queryAgentMentionsFragment$key = {
  readonly " $data"?: queryAgentMentionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"queryAgentMentionsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "queryAgentMentionsFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "creatorType"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "LinkedField",
      "name": "identityAccount",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "picture"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "identityAccountId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "AgentStudioAssistant"
};

(node as any).hash = "1c31489e6e76516963ed7f88e51ec981";

export default node;
